import * as React from "react";
import PhotoViewer from "src/share/components/PhotoViewer/PhotoViewer";

const defaultState = {
  boundingBoxes: [],
  isZoomed: false,
  source: "",
}

const PhotoViewerContext = React.createContext([] as any);

const PhotoViewerProvider = ({ children }) => {
  const [state, setState] = React.useState({ ...defaultState });
  return (
    <PhotoViewerContext.Provider value={[state, setState]}>
      <PhotoViewer />
      {children}
    </PhotoViewerContext.Provider>
  )
}

export { PhotoViewerContext, PhotoViewerProvider };


// WEBPACK FOOTER //
// ./src/share/context/PhotoViewerProvider.tsx